<mat-card>
  <mat-card-header>
    <mat-card-title class="flex justify-end w-full">
      <mat-icon class="mat-dialog-close" [mat-dialog-close]>close</mat-icon>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>
      <ng-container *ngFor="let text of textContent">
        <ng-container *ngIf="text.type === 'normal'; else linkText">
          <span>{{ text.content }}</span>
        </ng-container>
        <ng-template #linkText>
          <a
            class="underline font-semibold cursor-pointer"
            href="https://miri.viessmann-climatesolutions.com/support/catalog/items/285"
            target="_blank"
            gtm="onOpen"
            gtmAction="Miri support page"
            gtmCategory="trendingViunifyModal"
          >
            {{ text.content }}</a
          >
        </ng-template>
      </ng-container>
    </p>
  </mat-card-content>
  <mat-card-actions class="flex justify-end">
    <a
      class="no-underline"
      href="https://viunify.viessmann.net/"
      target="_blank"
      gtm="onOpen"
      gtmAction="Viunify page"
      gtmCategory="trendingViunifyModal"
    >
      <button mat-raised-button class="to-viunify_btn" color="primary" [mat-dialog-close]>
        {{ '+INSTALLATIONS.INSTALLATION.TRENDING.VIUNIFY_MODAL.TO_VIUNIFIY_BUTTON' | translate }}
      </button>
    </a>
  </mat-card-actions>
</mat-card>
